/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  showAllBooks,
  showFeaturedBooks
} from '../../../../redux/bookStore/status/actionCreators';

function BookListHeader() {
  const dispatch = useDispatch();
  const filterFeaturedHandler = e => {
    e.preventDefault();
    dispatch(showFeaturedBooks());
    document.getElementById('lws-filterAll').classList.remove('active-filter');
    document
      .getElementById('lws-filterFeatured')
      .classList.add('active-filter');
  };
  const noFilterFeaturedHandler = e => {
    e.preventDefault();
    dispatch(showAllBooks());
    document
      .getElementById('lws-filterFeatured')
      .classList.remove('active-filter');
    document.getElementById('lws-filterAll').classList.add('active-filter');
  };

  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>

      <div className="flex items-center space-x-4">
        <button
          className="filter-btn active-filter"
          id="lws-filterAll"
          onClick={noFilterFeaturedHandler}
        >
          All
        </button>
        <button
          className="filter-btn"
          id="lws-filterFeatured"
          onClick={filterFeaturedHandler}
        >
          Featured
        </button>
      </div>
    </div>
  );
}

export default BookListHeader;
